export const onRouteUpdate = () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      reg.update();
    });
  };
  
  export const onServiceWorkerUpdateReady = () => {
    console.log('Update Available');
    window.location.reload(true)
  };